import { Component, Input, Output, EventEmitter, OnChanges, OnInit, HostListener } from "@angular/core";
import { PackSubscriberService } from "@edp-services/pack-subscriber.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Component as ComponentModel, Pack, Category } from "./edp-pack.model";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { EdpModalService, EdpModalStatusComponent } from "@edp-components/edp-modal";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "@edp-environments/environment";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";
import { select, Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { getPack } from "@edp-store/selectors/contract.selectors";

@Component({
    selector: "edp-pack",
    templateUrl: "./edp-pack.component.html",
    styleUrls: ["./edp-pack.component.scss"],
})
export class EdpPackComponent implements OnInit, OnChanges {
    @Input() pack: Pack;
    @Input() showcase: boolean;
    @Input() isCollapsed = false;
    @Input() categoryBaseToSort: Array<{ title: string; order: number; height: null | number }> = [];
    @Output() categoryBaseToSortChange = new EventEmitter<Array<{ title: string; order: number; height: null | number }>>();
    @Output() private collapsedAll = new EventEmitter();
    @Output() private navigation = new EventEmitter();

    public grey_color_border = "#CCC";
    public grey_color_title = "#888";
    public mobileSize = false;

    public options: NgbModalOptions = {
        size: "lg",
    };

    public brandUrl: string;
    public partnerUrl: string;
    public highlightPackComponent: ComponentModel;
    public greenCategory: Category;
    public greenComponent: ComponentModel;
    public isApp: boolean;
    public hover: boolean;
    public isSelected: boolean;

    public constructor(
        private sanitizer: DomSanitizer,
        private packSubscriberService: PackSubscriberService,
        private edpModalService: EdpModalService,
        private translate: TranslateService,
        private store: Store<IAppState>
    ) {
    }

    public ngOnInit() {
        this.isApp = environment.isApp;
        this.insertComponent();
        this.onResize();

        if (!!sessionStorage.getItem("new-local-pack")) {
            this.store.pipe(select(getPack)).subscribe((pack: Pack) => {
                if (!!pack) {
                    this.isSelected = !!(pack.id === this.pack.id);
                }
            });
        }
    }

    @HostListener("window:resize")
    public onResize() {
        this.mobileSize = false;
        if (window.innerWidth < SCREEN_SIZES.WDGT) {
            this.mobileSize = true;
        }
    }

    ngOnChanges() {
        if (this.categoryBaseToSort.length > 0 && !this.mobileSize) {
            this.pack.components.forEach(component => {
                const categoryBase = this.categoryBaseToSort.find(({ title }) => component.category.title === title);
                if (categoryBase) {
                    const element = window.document.getElementById(`${this.pack.id}${component.category.title}`);
                    if (Number(element.offsetHeight) > 0 && Number(element.offsetHeight) > categoryBase.height) {
                        categoryBase.height = element.offsetHeight;
                        this.categoryBaseToSortChange.emit(this.categoryBaseToSort);
                    } else if (categoryBase.height) {
                        element.style.height = `${categoryBase.height}px`;
                    }
                }
            });
        }
    }

    private insertComponent() {
        this.greenCategory = {
            id: "1",
            icon: "icon-edponline-Bop-042",
            label: "pt.edponline.pack-component.category.energia",
            title: "Energia",
            reference: "energy",
        };

        this.greenComponent = {
            id: "0",
            title: "pt.edp.edponline.pack.greenEletricity",
            description: "",
            description_mobile: null,
            link: null,
            value: "",
            unit: "",
            type: "numeric",
            status: "1",
            category: this.greenCategory
        };

        if (this.pack.components.length > 1) {
            if (this.pack.components[1].title !== "pt.edp.edponline.pack.greenEletricity") {
                this.pack.components.splice(1, 0, this.greenComponent);
            }
        }
    }


    public selectPack(pack: Pack): void {
        this.packSubscriberService.setPack(pack);
        this.navigation.emit(pack);
    }

    public collapsed = () => {
        this.collapsedAll.emit();
    }

    public goBack = () => {
        this.navigation.emit();
    }


    public showDetails(colorPack: string, html: any) {
        const htmlTitle = `<span class="d-block text-center" style="color:${colorPack}">
                             <i class="icon-2x ${html.category.icon}"></i>
                             <p>${html.category.title}</p>
                           </span>`;

        const modalData = {
            title: "",
            messageHTML: htmlTitle + html.description,
            showClose: true,
            link: html.link
        };
        this.showSubmitModal(modalData);
    }

    private showSubmitModal(data: IModalData) {
        this.edpModalService.custom(EdpModalStatusComponent, this.options, data)
            .then(() => { /* Intentionally silent */ });
    }
}
